<div class="d-flex ap-mb-spacing-5 align-items-center">
  <gstar-entities-combobox
    [disabled]="disabled"
    [value]="entity"
    [preserveSelectionOnClientChange]="preserveSelectionOnClientChange"
    [required]="true"
    (selectEntity)="selectEntity($event)" />
  <div class="ms-auto ap-pl-spacing-5">
    <ap-button
      type="button"
      btnType="primary"
      icon="plus-outline"
      [disabled]="disabled"
      [label]="'upsertSecurity.addEntity' | translate"
      (onClick)="createEntity()" />
  </div>
</div>
<gstar-add-entity
  (newEntityCreated)="loadNewEntity($event)"
  [(showDrawer)]="showAddEntity" />
